import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Tabs, TabsList, TabsTrigger } from '@/ui/primitives';
import { PageShell } from '@/ui/layout';
import { MinhasTarefasView } from '@/modules/crm/components/MinhasTarefasView';
import { TabBadgeTarefas } from '@/modules/crm/components/TabBadgeTarefas';

export const Route = createFileRoute('/_authed/crm_/minhas-tarefas')({
  component: CrmMinhasTarefasPage,
});

function CrmMinhasTarefasPage() {
  const navigate = useNavigate();
  return (
    <PageShell
      eyebrow="Comercial"
      title="Oportunidades"
      lead="Pendências do diagnóstico viram oportunidade comercial."
    >
      <Tabs
        value="minhas-tarefas"
        onValueChange={(v) => {
          if (v === 'oportunidades') void navigate({ to: '/crm' });
          else if (v === 'lista') void navigate({ to: '/crm/lista' });
          else if (v === 'relatorios') void navigate({ to: '/crm/relatorios' });
        }}
      >
        <TabsList>
          <TabsTrigger value="oportunidades">Kanban</TabsTrigger>
          <TabsTrigger value="lista">Lista</TabsTrigger>
          <TabsTrigger value="minhas-tarefas">
            Minhas tarefas
            <TabBadgeTarefas />
          </TabsTrigger>
          <TabsTrigger value="relatorios">Relatórios</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="mt-4">
        <MinhasTarefasView />
      </div>
    </PageShell>
  );
}
